  <template id="template-select">
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    class="text-left"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :label="label"
      v-on:toggle-field="showSettings=!showSettings"
      v-on:collapse-field="collapse=!collapse"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
    />
    <!-- preview tab -->
    <b-collapse :class="isPreview ? 'mt-0': 'mt-5'" id="collapse-1" v-model="collapse">
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button
            v-if="fieldData.isConditional=='1' && !isPreview"
            variant="outline-dark"
            disabled
            title="This field is hidden by default and will display bt is controlled element"
          >
            <font-awesome-icon icon="eye-slash" />
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-left">
          <b-form-group
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            id="fieldset-1"
            :description="fieldData.helperText[selectedLanguage]"
            :invalid-feedback="fieldData.validationMessage[selectedLanguage]"
          >
            <label>
              <span
                v-if="fieldData.validation && fieldData.validation.required == 1"
                class="required-span"
              >*</span>
              {{fieldData.label[selectedLanguage]}}
            </label>

            <v-select
              :id="fieldData.id"
              :searchable="fieldData.configuration.isLiveSearchable"
              :clearable="fieldData.configuration.isClearable"
              :multiple="fieldData.configuration.isMultipleSelect"
              :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
              :disabled="isDisabled == 1"
              :options="renderOptions"
              v-model="selectedCurrency"
              @input="checkCondition"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- advance settings tab -->

      <b-modal
        cancel-title="Close"
        @ok="onSaveData"
        ok-title="save"
        size="xl"
        v-model="showSettings"
        title="Currency Advanced Settings"
        @hidden="onUpdateSettings"
      >
        <AdvanceSelectSettings
          v-if="showSettings"
          :fieldData="fieldData"
          v-on:toggle-field="showSettings=!showSettings"
          v-on:update-form-settings="getData"
          @label-text="label = $event"
          @helper-text="helperText = $event"
          :sectionIndex="sectionIndex"
          
        />
      </b-modal>
    </b-collapse>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
//import VSelect from "@alfsnd/vue-bootstrap-select";
import vSelect from "vue-select";
import MenuButtons from "../menuButtons";
import AdvanceSelectSettings from "../advanceRadioSettingsComponent.vue";
import { mapGetters, mapMutations, mapState } from "vuex";
import { EventBus } from "@/event-bus.js";

export default {
  name: "CurrencySelectGroup",
  components: {
    MenuButtons,
    AdvanceSelectSettings,
    vSelect,
  },
  data() {
    return {
      isHidden: false,
      isFocus: false,
      condition: {},
      showSettings: false,
      collapse: true,
      label: undefined,
      helperText: undefined,
      isRequired: 1,
      name: "",
      renderOptions: [],
      selectedCurrency: this.fieldData.selectedCurrency || null,
    };
  },
  created() {
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (value == "progress") {
        this.$store.state.validFields = true;
      } else {
        if (
          this.fieldData.validation &&
          this.fieldData.validation.required == 1
        ) {
          if (!this.selectedCurrency) {
            document
              .getElementById(this.fieldData.id)
              .scrollIntoView({ behavior: "smooth" });
            this.isFocus = true;
            this.$store.state.validFields = true;
          } else {
            this.$store.state.validFields = true;
          }
        }
      }
    });
  },
  computed: {
    ...mapGetters(["form1", "selectedLanguage"]),
    ...mapState(["toggleAllCoppalse", "userFormSubmitArray"]),
  },
  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    },
  },
  mounted() {
    this.isRequired = this.fieldData.validation.required;

    let getOptions = this.fieldData.options;
    getOptions.map((option) => {
      let optValue = option.value || "No Value Set";
      this.renderOptions.push(optValue);
    });
    if (
      this.$route.name == "userform" ||
      this.$route.name == "EmployeeUserFormPage" ||
      this.$route.name == "EmployeeComplaintFormPage" ||
      this.$route.name == "ViewComplaints"
    ) {
      this.setFieldValue();
    }
  },
  methods: {
    ...mapMutations(["TOGGLE_LOADER"]),
    onUpdateSettings() {
      this.TOGGLE_LOADER(2);
    },

    getData(data) {
      this.$emit("update-form-settings", data);
    },

    checkCondition(value) {
      this.isFocus = false;
      this.$store.state.validFields = true;

      let elements = this.form1.formSection[this.sectionIndex].formElements;
      let found = elements.find((ff, index) => {
        if (ff.conditions.length) {
          ff.conditions.map((aa) => {
            if (aa.sourceFieldId === this.fieldData.id && aa.value === value) {
              this.form1.formSection[this.sectionIndex].formElements[
                index
              ].isHidden = false;
            } else {
              this.form1.formSection[this.sectionIndex].formElements[
                index
              ].isHidden = true;
            }
          });
        } else {
          this.form1.formSection[this.sectionIndex].formElements[
            index
          ].isHidden = false;
        }
      });

      this.setValue(value);
    },

    setFieldValue() {
      this.$store.state.getUserFormSubmitArray.length &&
        this.$store.state.getUserFormSubmitArray.map((a, index) => {
          if (a.elementId === this.fieldData.id) {
            a.elements.map((el) => {
              return (this.selectedCurrency = el.postValue || null);
            });
          }
        });
    },

    setValue(e) {
      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        this.selectedCurrency = e;
        if (this.selectedCurrency) {
          this.userFormSubmitArray.find((a, index) => {
            if (a.elementId === this.fieldData.id) {
              a.elements[0] = {
                postValue: this.selectedCurrency,
                postName:
                  (this.fieldData.attributes &&
                    this.fieldData.attributes.postName) ||
                  "postNameCurrency",
              };
            }
          });
        }
      }
    },

    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
    },
  },

  validations: {
    selectedCurrency: {
      required,
    },
  },

  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>
<style>
.v-select.disabled .v-select-toggle[data-v-138dff1d] {
  background-color: white !important;
}
</style>

